import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames/bind';
import styles from './styles.styl';
import { Text } from '@consta/uikit/Text';
import { User } from '@consta/uikit/User';
import { Button } from '@consta/uikit/Button';
import { IconExit } from '@consta/uikit/IconExit';
import { loadUserLogout } from 'src/redux/features/logout/actions';
import { useHistory, useLocation } from 'react-router-dom';
import { PrivateRoutesEnum, PublicRoutesEnum } from 'src/utils/router';
import { loadUserInfo } from 'src/redux/features/userInfo/actions';
import { State } from 'src/redux/reducer';
import {
  userInfoLoadedSelector,
  userInfoPendingSelector,
  userInfoRejectedSelector,
  userInfoSelector,
} from 'src/redux/features/userInfo/selectors';
import { storageId } from 'src/utils/storage';
import { IUserInfo } from 'src/redux/features/userInfo/types';
import {
  Header as ConstaHeader,
  HeaderLogo,
  HeaderMenu,
  HeaderModule,
} from '@consta/uikit/Header';
import { useMediaQuery } from 'react-responsive';
import logo from 'src/assets/logo.png';

const cx = cn.bind(styles);

interface Item {
  label: string;
  href?: string;
  active?: boolean;
  onClick?: React.EventHandler<React.MouseEvent>;
  target?: string;
}

export interface IHeaderProps {
  loadUserLogout?: () => void;
  loadUserInfo?: (id: string | number) => void;
  userInfoLoaded?: boolean;
  userInfoRejected?: boolean;
  userInfoPending?: boolean;
  userInfo?: IUserInfo;
}

const Header: React.FC<IHeaderProps> = ({
  loadUserLogout,
  loadUserInfo,
  userInfo,
  userInfoLoaded,
}) => {
  const location = useLocation();

  const history = useHistory();

  const isMobile: boolean = useMediaQuery({ query: '(max-width: 424px)' });

  useEffect(() => {
    const userId = storageId();
    if (userId) loadUserInfo(userId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    loadUserLogout();
    history.push(PublicRoutesEnum.AUTH);
  };

  const items: Item[] = [
    {
      label: 'Мои опросы',
      href: PrivateRoutesEnum.DASHBOARD,
      active: location.pathname === PrivateRoutesEnum.DASHBOARD,
    },
    {
      label: 'Пройденные опросы',
      href: PrivateRoutesEnum.MU_SURVEY,
      active: location.pathname === PrivateRoutesEnum.MU_SURVEY,
    },
  ];
  return (
    <>
      <ConstaHeader
        className={cx('Header')}
        leftSide={
          <div className={cx('Header__tabs')}>
            <HeaderLogo>
              <img className={cx('Header__logo')} src={logo} />
            </HeaderLogo>
            {!isMobile && (
              <Text
                size="l"
                weight="semibold"
                className={cx('AuthModal__title')}
              >
                Название сервиса
              </Text>
            )}
            {!isMobile &&
              location.pathname.split('/').slice(1, 2).join('') !==
                'walkthrough' && (
                <HeaderModule indent="s">
                  <HeaderMenu items={items} />
                </HeaderModule>
              )}
          </div>
        }
        rightSide={
          <div className={cx('Header__user')}>
            {userInfoLoaded && (
              <User name={userInfo?.login} info="Администратор опросов" />
            )}
            <Button
              onlyIcon
              iconLeft={IconExit}
              view="clear"
              onClick={logout}
              className={cx('Header__button')}
            />
          </div>
        }
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  loadUserLogout: () => dispatch(loadUserLogout()),
  loadUserInfo: (id: string | number) => dispatch(loadUserInfo(id)),
});

export const mapStateToProps = (state: State, props: IHeaderProps) => ({
  userInfo: userInfoSelector(state),
  userInfoLoaded: userInfoLoadedSelector(state, props),
  userInfoRejected: userInfoRejectedSelector(state),
  userInfoPending: userInfoPendingSelector(state),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
